module.exports = __webpack_public_path__ + "img/steel-furnace-fire.4c04b78d.png";